import React, { useEffect } from 'react'
import LoginBG from '../../assets/svg/LoginBG.svg'
import UpstriveLoginLogo from '../../assets/svg/UpstriveLoginLogo.svg'
import '../../styles/UnauthenticatedApp.css'

const AuthLayout = ({ children, title }) => {
    useEffect(() => {
        document.getElementById('home-container').style.transitionDuration = '0'
        document.getElementById('home-container').style.marginLeft = '0px'
    }, [])

    return (
        <div className="min-h-screen w-full flex-auto pb-10" id="login-back">
            <div
                className="fixed inset-0 z-0 bg-cover bg-center bg-no-repeat"
                style={{ backgroundImage: `url(${LoginBG})` }}
                aria-hidden="true"
            />
            <div className="relative z-10 min-h-[100dvh] flex items-center justify-center overflow-y-auto overflow-x-hidden pb-5">
                <div className="w-full justify-center flex">
                    <div className="bg-deepPurple w-[530px] flex justify-center px-10 flex-col py-5 rounded-xl">
                        <div className="login-image-container flex justify-center mb-4">
                            <img src={UpstriveLoginLogo} alt="" className="w-[200px] mt-6" />
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AuthLayout
